import template from './wageAdvanceInfo.html';
import controller from './wageAdvanceInfo.controller';
import './wageAdvanceInfo.scss';

let wageAdvanceInfoComponent = {
  restrict: 'E',
  bindings: {
    isMobileApp: '<'
  },
  template,
  controller
};

export default wageAdvanceInfoComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceInfo/wageAdvanceInfo.component.js